import { bffInstance } from "../api/axiosInstance";
import { useQuery} from "react-query";
import { useApplicationStore } from "../home/ApplicationStore";
import {useDriveStore} from "./DriveStore";
import useUserProfileStore from "../core/UserProfileStore";
import { getAccessToken } from "../okta/authService";

export const getCNumbers = async () => {
  const response = await bffInstance.get(`/getLinkedDMS`);
  return response.data;
};

export const fetchDMSBoxMapping = async (enterpriseId:string) => {
  const response = await bffInstance.get(`/getDMSBoxMapping`,{
    headers: {
      "x-enterprise-id": enterpriseId,
    },
  });
  return response.data;
};

export const useGetCNumbers = () => {
  const { isDriveAppUser } = useApplicationStore();
  const store = useDriveStore();

  const query = useQuery({
    queryKey: ["getCNumbers"],
    queryFn: async () => {
      const data = await getCNumbers();
      return data;
    },
    onSuccess(data) {
      const transformedData = data.map((dms: any) => dms.cNumber);
      store.setCNumbers(transformedData);
    },
    enabled:  !!isDriveAppUser
  });

  return {
    data: store.cNumbers,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };


};


export function detectBrowser() {
  const ua = navigator.userAgent;
  const vendor = navigator.vendor;

  if (ua.toLowerCase().indexOf('edg/') !== -1) return "Microsoft Edge";
  if (/MSIE|Trident/.test(ua)) return "Internet Explorer";
  if (/Chrome/.test(ua) || /CriOS/.test(ua)) return "Google Chrome";
  if (/Firefox/.test(ua) || typeof window.InstallTrigger !== 'undefined') return "Mozilla Firefox";
  if (/Safari/.test(ua) && /Apple Computer/.test(vendor)) return "Apple Safari";
  if (/Opera|OPR/.test(ua)) return "Opera";

  return "Unknown Browser";
}

export const fetchEncryptParams = async (browser:string) => {
  const token = await getAccessToken();
  const response = await bffInstance.post('/encryptParams',
    {
      idToken: token,
      browser: browser
    });
    return response.data;
};

export function useEncryptParams() {
  const browser = detectBrowser();
  const { data } = useQuery('encryptParams', () => fetchEncryptParams(browser));
  return { data };
}

export const useFetchDMSBoxMapping = () => {
  const userProfile = useUserProfileStore();
  const { isDriveAppUser } = {isDriveAppUser:true};//useApplicationStore();
  const store = useDriveStore();
  
  const query = useQuery({
    queryKey: ["fetchDMSBoxMapping"],
    queryFn: () => fetchDMSBoxMapping(userProfile.enterpriseId),
    onSuccess(data) {
      store.setDMSBoxMapping(data);
    },
    enabled:  !!isDriveAppUser && !!userProfile.enterpriseId
  });

  return {
    data: store.dmsMapping,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
};